import { Path } from "./constants/paths";
import { createRouteSEO } from "./utils/seo-utils";

/**
 * SEO configuration for all static routes in the application
 */
export const seoConfig = {
  [Path.APP_MAIN]: createRouteSEO(
    "AlphaMind",
    "AlphaMind is a decentralized fundraising platform for blockchain projects. Participate in IDOs, build karma, and claim tokens.",
    { titleSuffix: " - Decentralized Fundraising Platform" }
  ),
  [Path.DASHBOARD]: createRouteSEO(
    "Dashboard",
    "View your AlphaMind dashboard with active and past IDOs, token holdings, and account information."
  ),
  [Path.BUILD_KARMA]: createRouteSEO(
    "Build Karma",
    "Increase your karma score on AlphaMind to get better allocation in upcoming IDOs and exclusive access to premium features."
  ),
  [Path.MYSTERY_BOX]: createRouteSEO(
    "Mystery Box",
    "Open mystery boxes on AlphaMind to win exclusive rewards, tokens, and NFTs."
  ),
  [Path.CLAIM]: createRouteSEO(
    "Claim Tokens",
    "Claim your tokens from successful IDO participation on AlphaMind platform."
  ),
  [Path.BRIDGE]: createRouteSEO(
    "Bridge",
    "Bridge your tokens across different blockchain networks securely with AlphaMind."
  ),
  [Path.REF_STATISTICS]: createRouteSEO(
    "Referral Statistics",
    "View your referral statistics and earnings on AlphaMind platform."
  ),
  // Dynamic routes will use a pattern that can be matched in the code
  "ido-detail": createRouteSEO(
    "IDO Details",
    "Detailed information about this IDO project, including tokenomics, team, roadmap, and participation details.",
    { isArticle: true }
  ),
};
